import type { Components } from '@mui/material/styles';

export const MuiIconButton = (): Partial<Components> => ({
  MuiIconButton: {
    styleOverrides: {
      root: {
        height: 'auto',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      },
      colorPrimary: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
});
